import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DeveloperDto } from '@dto';
import { RequestMethodEnum, RequestOptions } from '@model';
import { GenericService } from './generic.service';

const DEVELOPERS_ENDPOINT = 'api/v1/developers';

@Injectable()
export class DeveloperService {
  private _developers: DeveloperDto[];
  get developers(): DeveloperDto[] {
    return this._developers;
  }

  constructor(private resourceService: GenericService) {}

  developers$(): Observable<DeveloperDto[]> {
    const options: RequestOptions<undefined, DeveloperDto[]> = {
      method: RequestMethodEnum.GET,
      path: DEVELOPERS_ENDPOINT,
    };
    return this.resourceService.request(options).pipe(
      tap((developers: DeveloperDto[]) => {
        this._developers = developers;
      }),
    );
  }
}
